import React from 'react';
import { Text, View } from 'react-native';
import i18n from 'i18n-js';

import { scale } from '@components/frame';
import { font as initialFont } from '@styles/fonts';

const ConnectingMachine = ({ font = initialFont, C }) => {
  return (
    <View style={{ marginTop: scale(110), width: '100%', alignItems: 'center' }}>
      <Text style={[font['Body'], { color: C('Label/Light/Primary') }]}>{i18n.t('Connecting')}...</Text>
    </View>
  );
};

export default ConnectingMachine;
